const LOADING_MESSAGES = [
  'Beep boop...',
  'Thinking really hard...',
  'Consulting the data gods...',
  'Warming up the neurons...',
  'Crunching numbers...',
  'Summoning insights...',
  'Teaching machines to think...',
  'Asking the algorithm nicely...',
  'Herding cats...',
  'Untangling the data...',
  'Calibrating the vibes...',
  'Loading awesomeness...',
  'Making stuff up... just kidding...',
  'Almost there, probably...',
  'Polishing the pixels...',
];

export function getRandomLoadingMessage() {
  return LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)];
}
